import React from "react";
import { useFlags } from "flagsmith/react";

import Layout from "@components/Layout";
import Title from "@components/Title";

import PageControler from "@pages/User/NewRequest/resources";
import { FormProvider } from "@pages/User/NewRequest/resources/context/FormContext";

import { AvailableDatesProvider } from "./resources/context/AvailableDates/AvailableDates";
import { FormProviderRequestOrderOld } from "../NewRequestOld/FormContext";
import FormNewRequest from "../NewRequestOld/FormNewRequest";

const NewRequest = () => {
  const flags = useFlags(["user_home_card_new_order"]);

  return (
    <Layout>
      <div style={{ overflowY: "hidden" }}>
        {flags.user_home_card_new_order.enabled ? (
          <FormProvider>
            <AvailableDatesProvider>
              <PageControler />
            </AvailableDatesProvider>
          </FormProvider>
        ) : (
          <>
            <Title title="Novo Pedido" />
            <FormProviderRequestOrderOld>
              <FormNewRequest />
            </FormProviderRequestOrderOld>
          </>
        )}
      </div>
    </Layout>
  );
};

NewRequest.displayName = "NewRequest";

export default NewRequest;
